import { useEffect } from 'react';
import Highcharts from 'highcharts'
import Exporting from 'highcharts/modules/exporting'
import ExportData from 'highcharts/modules/export-data'
import HighchartsHeatmap from 'highcharts/modules/heatmap'
import Boost from 'highcharts/modules/boost'
import HighchartsReact from 'highcharts-react-official'

Exporting(Highcharts)
ExportData(Highcharts)
Boost(Highcharts)
HighchartsHeatmap(Highcharts)

export default function OcchrlyGraph(props) { 
  const { options } = props;
  //let allOptions = {}

  // Any of these options can be overridden via props.options
  const localOptions = {
    accessibility: {
      enabled:false,
    },
    chart: {
      type: 'heatmap',
      marginTop: 60,
      marginBottom: 80,
    },
    xAxis: { 
      type: "datetime",
      labels: {
        align: 'left',
        x: 5,
        y: 14,
        format: '{value:%b}' // short month
      },
      showLastLabel: false,
      ticklength: 16,
    },
    yAxis: {
      title: {
        text: null,
      },
      labels: {
        format: '{value}:00'
      },
//      startOnTick: false,
//      endOnTick: false,
//      tickPositions: [24, 18, 12, 6],
      tickWidth: 1,
      categories: [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24],
//      min: 1,
//      max: 24,
//      reverse: true,
    },
    colorAxis: {
        stops: [
          [0, '#FF0000'], // Red
          [0.2, '#FFA500'], // Orange
          [0.4, '#FFFF00'], // Yellow
          [0.6, '#00FF00'], // Green
          [0.8, '#0000FF'], // Blue
          [1, '#800080']  // Violet]
        ]
    },
    credits: {
      href: "https://www.rcc-acis.org",
      text: "Powered by ACIS",
    },
    title: {
      text: "",
    },
    // Following must be provided via options.series in props
    series: null
  };
 
  console.log( { ...localOptions, ...options })   

  return (
    <>
      {options && options.series &&
        <HighchartsReact
          highcharts={Highcharts}
          options={{ ...localOptions, ...options }}
        />
      }
    </>
  )
}